/* eslint-disable import/prefer-default-export */
import diff from 'deep-diff';

export const isContentEquivalent = (first, second) => {
  const filterBlockKeys = (content) => ({
    ...content,
    blocks: content.blocks.map(({ key, ...block }) => block),
  });
  const firstWithoutKeys = filterBlockKeys(first);
  const secondWithoutKeys = filterBlockKeys(second);
  return !diff(firstWithoutKeys, secondWithoutKeys);
};
